import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { PlexTokenInterceptor } from 'common/interceptors/plextoken.intercentor';
import { DesktopHeaderModule } from 'common/components/desktop-header/desktop-header.module';
import { DesktopFooterModule } from 'common/components/desktop-footer/desktop-footer.module';
import { Network } from '@ionic-native/network/ngx';
import { IonicStorageModule } from '@ionic/storage-angular';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { LoaderModule } from 'common/components/loader/loader.module';
import { NoInternetModule } from 'common/components/no-internet/no-internet.module';
import { TabsModule } from 'common/components/tabs/tabs.module';
import { SidePanelModule } from 'common/components/side-panel/side-panel.module';
import { ModalPopUpModule } from 'common/components/modal-pop-up/modal-pop-up.module';
import { ButtonModule } from 'common/components/button/button.module';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { UnderMaintenanceModule } from 'common/components/under-maintenance/under-maintenance.module';
import { GlobalErrorHandler } from 'common/utils/GlobalErrorHandler';

@NgModule({
    declarations: [AppComponent],
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: PlexTokenInterceptor, multi: true },
        { provide: ErrorHandler, useClass: GlobalErrorHandler }, // Register custom error handler
        Network,
        SocialSharing,
        FileOpener,
        // { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot({ scrollAssist: false, scrollPadding: false, inputShims: true, innerHTMLTemplatesEnabled: true }),
        IonicStorageModule.forRoot(),
        AppRoutingModule,
        NgbModule,
        HttpClientModule,
        DesktopHeaderModule,
        DesktopFooterModule,
        LoaderModule,
        NoInternetModule,
        TabsModule,
        SidePanelModule,
        ModalPopUpModule,
        ButtonModule,
        UnderMaintenanceModule,
        BackButtonDisableModule.forRoot({
            preserveScroll: true,
        }),
    ],
})
export class AppModule { }
